export const getUsersIds = (ids = []) => ids.map(member => member.id);
